import React from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules'; // Navigation add kiya
import 'swiper/css';
import 'swiper/css/navigation'; // Navigation CSS

const Clients = () => {
    const clientLogos = [
        'cl-logo-1.png', 'cl-logo-2.png', 'cl-logo-3.png', 'cl-logo-4.png',
        'cl-logo-5.png', 'cl-logo-6.png', 'cl-logo-7.png', 'cl-logo-8.png',
        'cl-logo-9.png', 'cl-logo-10.png'
    ];

    return (
        <section id="clients" className="py-20 bg-white">
            <div className="max-w-7xl mx-auto px-6 text-center">
                <h3 className="text-[#f15a24] font-bold tracking-widest uppercase text-sm mb-2">
                    Corporate Stories That Matter
                </h3>
                <h2 className="text-4xl font-bold text-gray-900 mb-12">OUR CLIENTS</h2>

                {/* Swiper Slider with Navigation */}
                <Swiper
                    modules={[Autoplay, Navigation]} // Navigation module add kiya
                    spaceBetween={30}
                    slidesPerView={2}
                    loop={true}
                    navigation={true} // Left/Right arrows enabled
                    autoplay={{ delay: 2000, disableOnInteraction: false }}
                    breakpoints={{
                        640: { slidesPerView: 3 },
                        1024: { slidesPerView: 5 },
                    }}
                    className="mb-12 px-10" // Arrows ke liye padding
                >
                    {clientLogos.map((logo, index) => (
                        <SwiperSlide key={index}>
                            <div className="bg-white p-6 rounded-xl border border-gray-100 shadow-sm hover:shadow-xl transition-all duration-300 flex items-center justify-center h-32">
                                <img
                                    src={`/${logo}`}
                                    alt={`Client ${index + 1}`}
                                    // Grayscale hata diya hai, ab images color mein dikhengi
                                    className="h-full w-full object-contain transition-transform duration-300 hover:scale-110"
                                />
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>

                <Link
                    to="/about"
                    className="mt-12 bg-gray-900 text-white px-12 py-5 font-black text-lg hover:bg-[#f15a24] transition duration-300 inline-block"
                >
                    ABOUT MORE →
                </Link>
            </div>
        </section>
    );
};

export default Clients;